module.exports = __webpack_public_path__ + "assets/img/rank2.d8093282.png";